import messageErr from "@/constants/messageErr.json";
import { freeGasManagerService } from "@/contracts";
import { User } from "@/model";
import { IdType } from "@/types";
import { getAccount, getPublicClient, writeContract } from "@wagmi/core";
export const handleIdType = (user: User) => {
  if (user?.passportId && user?.idCard) {
    return { idType: IdType.PASSPORT, idValue: user?.passportId };
  }
  if (user?.idCard) {
    return { idType: IdType.ID_CARD, idValue: user?.idCard };
  }
  if (user?.phoneNumber) {
    return { idType: IdType.PHONE, idValue: user.phoneNumber };
  }
  if (user?.email) {
    return { idType: IdType.EMAIL, idValue: user.email };
  }
  return {
    idType: IdType.PASSPORT,
    idValue: user?.passportId || "udf",
  };
};

export const handleWriteContract = async (request) => {
  try {
    const account = getAccount();
    const publicClient = getPublicClient();
    const gasPrice = await publicClient.getGasPrice();

    const gasEstimate = await publicClient.estimateContractGas({
      ...request,
      account,
    });

    const { hash } = await writeContract({
      ...request,
      gasPrice,
      gas: gasEstimate,
    });

    return hash;
  } catch (err) {
    throw err;
  }
};

export async function handleErrorGasFree({ key }: { key: string }) {
  let messageTemplate = messageErr[key] || messageErr["give_gas_failed"];

  if (key === "F1") {
    const hours = await freeGasManagerService.period();
    return messageTemplate.replace("{{hours}}", String(hours));
  }

  return messageTemplate;
}
